

















// @ts-ignore
import v8n from 'v8n';
import moment from 'moment';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { ApiError } from '@/api';
import { snackModule } from '@/store';

@Component({
  components: {},
})
export default class extends Vue {
  loading: boolean = false;

  filters: {
    rego?: string;
  } = {};

  save() {
    this.$emit('do-filter', this.filters);
  }
}
